import api from '@/services/api';
import localStorage from '@/components/Services/storage';
import router from '@/router/index';

export default {
    /**
     * Get user main data when user log in
     *
     * @param context
     */
    getUserAccounts(context) {
        api.get('/api/me'+(localStorage.get('phone', true) ? '/'+localStorage.get('phone', true) : ''))
            .then((response) => {
                context.commit('SET_USER_CONTRACTS', {
                    contracts: response.data.body.user.contracts,
                });
            })
            .catch(() => {
                // Token expired or invalid token
                localStorage.remove('token');
            });
    },

    /**
     * On click in float box menu, change chosen contract
     * @param context
     * @param payload
     */
    setClickedContract(context, payload) {
        // If contract is expanded and clicked again, dont send again api call
        if (context.getters.contract.clickedContract.contractId === payload.contractId && context.getters.contract.clickedContract.productId === payload.productId) {
            return;
        }

        if (payload.isMobile) {
            router.replace('/');
        }

        if (payload.isTv) {
            router.replace('/tv');
        }

        if (payload.isInternet) {
            router.replace('/internet');
        }

        // On change contract, update data for that contract
        context.dispatch('getUserAccounts');
        context.dispatch('setResources', {}, { root: true });

        context.commit('SET_CLICKED_CONTRACT', {
            contract: payload,
        });

        localStorage.save('selectedContractId', payload.contractId, true);

        context.dispatch('setGdpr', {}, { root: true });
    },
};
